import { defineMessages } from "react-intl";

import LeadFinderSubscriptionPlan, {
  UpgradeTargetPlan,
} from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";

export const planMessages = defineMessages<UpgradeTargetPlan>({
  [LeadFinderSubscriptionPlan.ADVANCED]: {
    id: "settings.organizationDetails.leadGen.upsell.options.advanced",
    defaultMessage:
      "{noPlan, select, true {{isOwner, select, true {Add} other {Get}}} other {Upgrade to}} <b>Lead Finder Advanced</b> for 125 monthly searches per user",
  },
  [LeadFinderSubscriptionPlan.ELITE]: {
    id: "settings.organizationDetails.leadGen.upsell.options.starter",
    defaultMessage:
      "{noPlan, select, true {{isOwner, select, true {Add} other {Get}}} other {Upgrade to}} <b>Lead Finder Elite</b> for 200 monthly searches per user",
  },
  [LeadFinderSubscriptionPlan.STARTER]: {
    id: "settings.organizationDetails.leadGen.upsell.options.elite",
    defaultMessage:
      "{noPlan, select, true {{isOwner, select, true {Add} other {Get}}} other {Upgrade to}} <b>Lead Finder Starter</b> for 75 monthly searches per user",
  },
});
